// React
import { useEffect, useMemo, useState } from "react"
import { useNavigate } from "react-router-dom"

// Components
import PersonalInfo from "./PersonalInfo"
import ContactInfo from "./ContactInfo"
import MilitaryInfo from "./MilitaryInfo"
import EducationInfo from "./EducationInfo"
// import JobsPositionInfo from "../JobsPositionInfo/JobsPositionInfo"
import AddressInfo from "../AddressInfo/AddressInfo"

// Hooks and Redux
import { useDispatch } from "react-redux"

import {
  editPrefix,
  editFirstNameTH,
  editLastNameTH,
  editFirstNameEN,
  editLastNameEN,
  editGender,
  editReligion,
  editMaritalStatus,
  editWeight,
  editHeight,
  editDateOfBirth,
  editIdCardNumber,
  editPhoneNumber,
  editEmail,
  editLineID,
  editEmergencyPerson,
  editEmergencyPhone,
  editRelationship,
  editeducation_level,
  editeducation_levelOther,
  editSchool,
  editMilitaryStatus,
  editLegalAddressHouseNo,
  editLegalAddressVillageNo,
  editLegalAddressAlley,
  editLegalAddressRoad,
  editLegalAddressProvince,
  editLegalAddressDistrict,
  editLegalAddressSubDistrict,
  editLegalAddressZipCode,
  editMailingAddressHouseNo,
  editMailingAddressVillageNo,
  editMailingAddressAlley,
  editMailingAddressRoad,
  editMailingAddressProvince,
  editMailingAddressDistrict,
  editMailingAddressSubDistrict,
  editMailingAddressZipCode,
  editMailingSameAsLegalAddress,
  editStartDateOfWork,
  editWorkExperience,
  editNationality,
} from "../../../../redux/slices/jobAppSlice"
// Hooks and Redux
import { useAppSelector } from "../../../../redux/hooks"

// MUI Components
import { ThemeProvider } from "@mui/material/styles"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Select, { SelectChangeEvent } from "@mui/material/Select"
import CircularProgress from "@mui/material/CircularProgress"
import DialogTitle from "@mui/material/DialogTitle"
import DialogContent from "@mui/material/DialogContent"
import DialogActions from "@mui/material/DialogActions"
import Dialog from "@mui/material/Dialog"

// Services
import {
  getAppFormById,
  editAppFormById,
} from "../../../../services/AppFormService"
import {
  fetchDistricts,
  fetchSubDistricts,
  fetchProvinces,
} from "../AddressInfo/fetchGeoData"

// Utils
import newAdapter from "../../../../utils/newAdapter"
import dayjs, { Dayjs } from "dayjs"
import { useTranslation } from "react-i18next"
import Swal from "sweetalert2"
import jwtDecode from "jwt-decode"
import { useForm } from "react-hook-form"

// Styles
import { green } from "@mui/material/colors"
import theme from "../../../../styles/theme"

// Types
import { TokenPayload, Site } from "../../../../@types"
import { AppFormStatus } from "../../../../@types"

// Services
import {
  getAllActiveBank,
  // getAllActiveCompany, //เปลี่ยนมาใช้ useAppSelector
  getAllActiveCountry,
  getAllActiveHolidaySchedule,
  getAllActiveIncentiveGroup,
  getAllActiveMaritalStatus,
  getAllActivePayGrade,
  getAllActivePayGroup,
  getAllActiveReligion,
  getAllActiveWorkGroup,
  getAllActiveWorkSchedule,
  // getAllActivePrefix, //เปลี่ยนมาใช้ useAppSelector
} from "../../../../services/MasterDataService"
// import { getAllSites } from "../../../../services/SiteService" //เปลี่ยนมาใช้ useAppSelector
// import Swal from "sweetalert2"
import Alert from "@mui/material/Alert"
import AlertTitle from "@mui/material/AlertTitle"

import { editECData, getECDataById } from "../../../../services/ECService"

import { Autocomplete, AutocompleteRenderInputParams } from "@mui/material"
import match from "autosuggest-highlight/match"
import parse from "autosuggest-highlight/parse"
import { AppFormData } from "../../../../@types/AppFormData.type"

import { checkUsername } from "../../../../services/UserService"

export interface InputDataToECProps {
  edit_id: string
  keepMounted: boolean
  open: boolean
  onClose: (value?: boolean) => void
}

export default function EditJobDetailData(props: InputDataToECProps) {
  const { edit_id, onClose, open, ...other } = props
  const navigate = useNavigate()
  const { t, i18n } = useTranslation()
  const parsedToken: TokenPayload = jwtDecode(localStorage.access_token)
  const dispatch = useDispatch()
  const {
    personalInfo,
    contactInfo,
    educationInfo,
    legalAddressInfo,
    mailingAddressInfo,
    jobInfo,
  } = useAppSelector((state) => state.jobapp)

  const [personalInfoErrors, setPersonalInfoErrors] = useState({})
  const [contactInfoErrors, setContactInfoErrors] = useState({})
  const [educationInfoErrors, setEducationInfoErrors] = useState({})
  const [militaryInfoErrors, setMilitaryInfoErrors] = useState({})
  const [legalAddressInfoErrors, setLegalAddressInfoErrors] = useState({})
  const [mailingAddressInfoErrors, setMailingAddressInfoErrors] = useState({})
  const [jobInfoErrors, setJobInfoErrors] = useState({})
  const [textValidate, setTextValidate] = useState<string>("")
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const [dupUserId, setDupUserId] = useState<string>("")

  const [appFormData, setAppFormData] = useState<AppFormStatus | null>(null)
  const [ageStatus, setAgeStatus] = useState<boolean>(false)

  const [nationalID, setNationalID] = useState<string>("")
  const [countryOfNationalID, setCountryOfNationalID] = useState<string>("")
  const [nationalIDCardType, setNationalIDCardType] = useState<string>("")
  const [countryOfBirth, setCountryOfBirth] = useState<string>("")
  const [dateOfBirth, setDateOfBirth] = useState<Dayjs | null>(null)
  const [prefix, setPrefix] = useState<string>("")
  const [firstNameTH, setFirstNameTH] = useState<string>("")
  const [lastNameTH, setLastNameTH] = useState<string>("")
  const [firstNameEN, setFirstNameEN] = useState<string>("")
  const [lastNameEN, setLastNameEN] = useState<string>("")
  const [gender, setGender] = useState<string>("")
  const [weight, setWeight] = useState("")
  const [height, setHeight] = useState("")
  const [nationality, setNationality] = useState<string>("")
  const [maritalStatus, setMaritalStatus] = useState<string>("")
  const [religion, setReligion] = useState<string>("")
  const [idCardNumber, setIdCardNumber] = useState<string>("") //id_card_number

  const [phoneNumber, setPhoneNumber] = useState<string>("")
  const [legalCountry, setLegalCountry] = useState<string>("")
  const [legalHouseNumber, setLegalHouseNumber] = useState<string>("")
  const [legalMoo, setLegalMoo] = useState<string>("")
  const [legalStreet, setLegalStreet] = useState<string>("")
  const [legalLane, setLegalLane] = useState<string>("")
  const [legalSubDistrict, setLegalSubDistrict] = useState<string>("")
  const [legalDistrict, setLegalDistrict] = useState<string>("")
  const [legalProvince, setLegalProvince] = useState<string>("")
  const [legalPostalCode, setLegalPostalCode] = useState<string>("")
  const [sameAsLegal, setSameAsLegal] = useState<boolean>(false)
  const [mailingCountry, setMailingCountry] = useState<string>("")
  const [mailingHouseNumber, setMailingHouseNumber] = useState<string>("")
  const [mailingMoo, setMailingMoo] = useState<string>("")
  const [mailingStreet, setMailingStreet] = useState<string>("")
  const [mailingLane, setMailingLane] = useState<string>("")
  const [mailingSubDistrict, setMailingSubDistrict] = useState<string>("")
  const [mailingDistrict, setMailingDistrict] = useState<string>("")
  const [mailingProvince, setMailingProvince] = useState<string>("")
  const [mailingPostalCode, setMailingPostalCode] = useState<string>("")

  const [selectedHireDate, setSelectedHireDate] = useState<Dayjs | null>(
    dayjs()
  )
  const [positionId, setPositionId] = useState<string>("")
  const [selectedCompany, setSelectedCompany] = useState<string>("")
  const [selectedIncentiveGroup, setSelectedIncentiveGroup] =
    useState<string>("")
  const [selectedPayGrade, setSelectedPayGrade] = useState<string>("")
  const [selectedWorkSchedule, setSelectedWorkSchedule] = useState<string>("")
  const [selectedHolidaySchedule, setSelectedHolidaySchedule] =
    useState<string>("")
  const [selectedWorkGroup, setSelectedWorkGroup] = useState<string>("")
  const [selectedContractStartDate, setSelectedContractStartDate] =
    useState<Dayjs | null>(null)
  const [selectedContractEndDate, setSelectedContractEndDate] =
    useState<Dayjs | null>(null)
  const [selectedBank, setSelectedBank] = useState<string>("")
  const [bankAccountNumber, setBankAccountNumber] = useState<string>("")
  const [selectedPayGroup, setSelectedPayGroup] = useState<string>("")
  const [Amount101, setAmount101] = useState<string>("")
  const [Amount102, setAmount102] = useState<string>("")
  const [Amount103_1, setAmount103_1] = useState<string>("")
  const [Amount125, setAmount125] = useState<string>("")
  const [Amount128, setAmount128] = useState<string>("")
  const [Amount133, setAmount133] = useState<string>("")
  const [Amount163, setAmount163] = useState<string>("")

  const [countryList, setCountryList] = useState<
    { country_code: string; country_name: string }[]
  >([])
  const [religionList, setReligionList] = useState<
    { external_code: string; label: string }[]
  >([])
  const [maritalStatusList, setMaritalStatusList] = useState<
    { external_code: string; label: string }[]
  >([])

  // เปลี่ยนมาใช้ useAppSelector
  // const [companyList, setCompanyList] = useState<
  //   { company_code: string; company_name: string }[]
  // >([])
  const { companies: companyList, prefixes: prefixList, sites: masterSites } = useAppSelector(
    (state) => state.masterData
  )
  const [payGradeList, setPayGradeList] = useState<
    { external_code: string; label: string }[]
  >([])
  const [incentiveGroupList, setIncentiveGroupList] = useState<
    { external_code: string; label: string }[]
  >([])
  const [workScheduleList, setWorkScheduleList] = useState<
    { external_code: string; label: string }[]
  >([])
  const [holidayScheduleList, setHolidayScheduleList] = useState<
    { external_code: string; label: string }[]
  >([])
  const [workGroupList, setWorkGroupList] = useState<
    { external_code: string; label: string }[]
  >([])
  const [bankList, setBankList] = useState<
    { bank_code: string; bank_name: string }[]
  >([])
  const [payGroupList, setPayGroupList] = useState<
    { pay_group_id: string; label: string }[]
  >([])

  const [loadingCountryList, setLoadingCountryList] = useState<boolean>(true)
  const [loadingReligionList, setLoadingReligionList] = useState<boolean>(true)
  const [loadingMaritalStatusList, setLoadingMaritalStatusList] =
    useState<boolean>(true)
  const [loadingCompanyList, setLoadingCompanyList] = useState<boolean>(false) // เปลี่ยนมาใช้ useAppSelector (ข้อมูลพร้อมใช้จาก store แล้ว)
  const [loadingPayGradeList, setLoadingPayGradeList] = useState<boolean>(true)
  const [loadingIncentiveGroupList, setLoadingIncentiveGroupList] =
    useState<boolean>(true)
  const [loadingWorkScheduleList, setLoadingWorkScheduleList] =
    useState<boolean>(true)
  const [loadingHolidayScheduleList, setLoadingHolidayScheduleList] =
    useState<boolean>(true)
  const [loadingWorkGroupList, setLoadingWorkGroupList] =
    useState<boolean>(true)
  const [loadingBankList, setLoadingBankList] = useState<boolean>(true)
  const [loadingPayGroupList, setLoadingPayGroupList] = useState<boolean>(true)

  const [loadingECData, setLoadingECData] = useState<boolean>(true)
  const [submittedLoading, setSubmittedLoading] = useState<boolean>(false)
  // เปลี่ยนมาใช้ useAppSelector
  // const [prefixList, setPrefixList] = useState<any>([])
  const allSuccessLoading =
    !loadingCountryList &&
    !loadingReligionList &&
    !loadingMaritalStatusList &&
    !loadingCompanyList &&
    !loadingPayGradeList &&
    !loadingIncentiveGroupList &&
    !loadingWorkScheduleList &&
    !loadingHolidayScheduleList &&
    !loadingWorkGroupList &&
    !loadingBankList &&
    !loadingPayGroupList &&
    !loadingECData

  const [statusValidate, setStatusValidate] = useState<boolean>(false)

  const [selectedConfirmJobs, setSelectedConfirmJobs] =
    useState<string>("false")
  const [jobREmail, setjobREmail] = useState<string>("")
  // เปลี่ยนมาใช้ useAppSelector
  // const [siteData, setSiteData] = useState<Site[]>([])
  const siteData = useMemo(
    () =>
      [...masterSites]
        .sort((a: Site, b: Site) => a.site_id.localeCompare(b.site_id))
        .filter((site: Site) => site.is_active === true),
    [masterSites]
  )
  const [selectedSite, setSelectedSite] = useState<string>("") //app_form_Data.Job.Site.site_id
  const emailRegex = /^[a-zA-Z0-9._-]+@betagro\.com$/

  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm()

  //   const isNumeric = (value: string): boolean => {
  //     return /^-?\d+$/.test(value)
  //   }

  //   const validateThaiCitizenID = async (id: string) => {
  //     // Remove any non-digit characters from the ID
  //     id = id.replace(/\D/g, "")

  //     // Check if the ID has the correct length (13 digits)
  //     if (id.length !== 13) {
  //       return false
  //     }

  //     // Convert the ID to an array of digits
  //     const digits = id.split("").map(Number)

  //     // Calculate the checksum
  //     let sum = 0
  //     for (let i = 0; i < 12; i++) {
  //       sum += digits[i] * (13 - i)
  //     }

  //     // Check if the last digit matches the checksum
  //     const checksum = (11 - (sum % 11)) % 10
  //     return digits[12] === checksum
  //   }

  //   const checkIDCard = async (id: string) => {
  //     const validateStatus = await validateThaiCitizenID(id)
  //     if (validateStatus && isNumeric(id)) {
  //       setStatusValidate(true)
  //     } else {
  //       setStatusValidate(false)
  //     }
  //   }
  const handleReligionChange = (event: SelectChangeEvent) => {
    setReligion(event.target.value as string)
    dispatch(editReligion(event.target.value as string))
  }

  useEffect(() => {
    const fetchAppFormData = async () => {
      const response = await getAppFormById(edit_id)

      if (response) {
        if (!response.data?.success) {
          Swal.fire({
            title:
              i18n.language === "th"
                ? response.data?.message_th
                : response.data?.message_en,
            icon: "error",
            showCancelButton: false,
            confirmButtonColor: "#43A047",
            confirmButtonText: "OK!",
            allowOutsideClick: false,
            allowEscapeKey: false,
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.assign("/admin/application-form")
            }
          })
          return
        }

        const data = response.data?.AppFormStatusData

        if (!data) {
          Swal.fire({
            title: i18n.language === "th" ? "ไม่พบข้อมูล" : "Not found",
            icon: "error",
            showCancelButton: false,
            confirmButtonColor: "#43A047",
            confirmButtonText: "OK!",
            allowOutsideClick: false,
            allowEscapeKey: false,
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.assign("/admin/application-form")
            }
          })
          return
        }

        setAppFormData(data)
        setPrefix(data.AppFormData.prefix)
        setFirstNameTH(data.AppFormData.first_name_th)
        setLastNameTH(data.AppFormData.last_name_th)
        setFirstNameEN(data.AppFormData.first_name_en)
        setLastNameEN(data.AppFormData.last_name_en)
        setIdCardNumber(data.AppFormData.id_card_number)
        setGender(data.AppFormData.gender)
        setWeight(data.AppFormData.weight)
        setHeight(data.AppFormData.height)
        setNationality(data.AppFormData.nationality)
        setMaritalStatus(data.AppFormData.marital_status)
        setReligion(data.AppFormData.religion)
        setDateOfBirth(
          data.AppFormData.date_of_birth
            ? dayjs(data.AppFormData.date_of_birth)
            : null
        )

        setPhoneNumber(data.AppFormData.phone_number)
        setjobREmail(data.AppFormData.job_relationship_email)
        setSelectedSite(data.AppFormData.site_id)

        // dispatch data
        dispatch(editPrefix(data.AppFormData.prefix || ""))
        dispatch(editFirstNameTH(data.AppFormData.first_name_th || ""))
        dispatch(editLastNameTH(data.AppFormData.last_name_th || ""))
        dispatch(editFirstNameEN(data.AppFormData.first_name_en || ""))
        dispatch(editLastNameEN(data.AppFormData.last_name_en || ""))
        dispatch(editGender(data.AppFormData.gender || ""))
        dispatch(editReligion(data.AppFormData.religion || ""))
        dispatch(editMaritalStatus(data.AppFormData.marital_status || ""))
        dispatch(editNationality(data.AppFormData.nationality || ""))
        dispatch(editHeight(data.AppFormData.height || ""))
        dispatch(editWeight(data.AppFormData.weight || ""))
        dispatch(editDateOfBirth(data.AppFormData.date_of_birth || ""))
        dispatch(editIdCardNumber(data.AppFormData.id_card_number || ""))
        dispatch(editPhoneNumber(data.AppFormData.telephone || ""))
        dispatch(editEmail(data.AppFormData.email || ""))
        dispatch(editLineID(data.AppFormData.line_id || ""))
        dispatch(editEmergencyPerson(data.AppFormData.emergency_name || ""))
        dispatch(editEmergencyPhone(data.AppFormData.emergency_phone || ""))
        dispatch(editRelationship(data.AppFormData.emergency_relation || ""))
        dispatch(editeducation_level(data.AppFormData.education_level || ""))
        dispatch(editSchool(data.AppFormData.education_school || ""))
        dispatch(editMilitaryStatus(data.AppFormData.military_status || ""))
        dispatch(editWorkExperience(data.AppFormData.work_experience || ""))
        dispatch(editStartDateOfWork(data.AppFormData.start_date || ""))
        dispatch(
          editMailingSameAsLegalAddress(data.AppFormData.same_address || true)
        )
        // mailingAddressInfo
        const legal_address = data.AppFormData.AppFormAddress.find(
          (address: any) => address.address_type === "LEGAL"
        )
        const mailing_address = data.AppFormData.AppFormAddress.find(
          (address: any) => address.address_type === "MAILING"
        )

        const highestEdu = data.AppFormData.education_level || ""
        const highestEduOption = [
          "ไม่มีวุฒิการศึกษา",
          "ประถมศึกษา",
          "มัธยมต้น",
          "มัธยมปลาย",
          "ปวช,",
          "ปวส.",
        ]
        if (!highestEduOption.includes(highestEdu)) {
          dispatch(editeducation_level("อื่น ๆ"))
          dispatch(editeducation_levelOther(highestEdu))
        }

        const provinceData = await fetchProvinces()
        const districtData = await fetchDistricts()
        const subDistectData = await fetchSubDistricts()

        const legalProvince = provinceData.find(
          (province: any) =>
            province.external_code === parseInt(legal_address.address_province)
        )
        const legalDistrict = districtData.find(
          (district: any) => district.name_th === legal_address.address_district
        )
        const legalSubDistrict = subDistectData.find(
          (subDistrict: any) =>
            subDistrict.name_th === legal_address.address_sub_district
        )

        dispatch(editLegalAddressProvince(legalProvince || ""))
        dispatch(editLegalAddressDistrict(legalDistrict || ""))
        dispatch(editLegalAddressSubDistrict(legalSubDistrict || ""))
        dispatch(
          editLegalAddressHouseNo(legal_address.address_house_number || "")
        )
        dispatch(editLegalAddressVillageNo(legal_address.address_moo || ""))
        dispatch(editLegalAddressAlley(legal_address.address_lane || ""))
        dispatch(editLegalAddressRoad(legal_address.address_street || ""))
        dispatch(
          editLegalAddressZipCode(
            parseInt(legal_address.address_postal_code) || ""
          )
        )
        dispatch(editMailingSameAsLegalAddress(true))

        if (mailing_address) {
          const mailingProvince = provinceData.find(
            (province: any) =>
              province.external_code ===
              parseInt(mailing_address.address_province)
          )
          const mailingDistrict = districtData.find(
            (district: any) =>
              district.name_th === mailing_address.address_district
          )
          const mailingSubDistrict = subDistectData.find(
            (subDistrict: any) =>
              subDistrict.name_th === mailing_address.address_sub_district
          )

          dispatch(editMailingAddressProvince(mailingProvince || ""))
          dispatch(editMailingAddressDistrict(mailingDistrict || ""))
          dispatch(editMailingAddressSubDistrict(mailingSubDistrict || ""))
          dispatch(
            editMailingAddressHouseNo(
              mailing_address.address_house_number || ""
            )
          )
          dispatch(
            editMailingAddressVillageNo(mailing_address.address_moo || "")
          )
          dispatch(editMailingAddressAlley(mailing_address.address_lane || ""))
          dispatch(editMailingAddressRoad(mailing_address.address_street || ""))
          dispatch(
            editMailingAddressZipCode(
              parseInt(mailing_address.address_postal_code) || ""
            )
          )
          dispatch(editMailingSameAsLegalAddress(false))
        }
      }
    }
    fetchAppFormData()
  }, [navigate, open, edit_id])

  useEffect(() => {
    const fetchAllActiveCountry = async () => {
      try {
        const response = await getAllActiveCountry("Active")

        if (response.data?.success) {
          setCountryList(response?.data?.countries)
        }
      } catch (error) {
        console.log(error)
        navigate("/servererror", { replace: true })
      } finally {
        setLoadingCountryList(false)
      }
    }

    const fetchAllActiveReligion = async () => {
      try {
        const response = await getAllActiveReligion("Active")

        if (response.data?.success) {
          setReligionList(response.data?.religions)
        }
      } catch (error) {
        console.log(error)
      } finally {
        setLoadingReligionList(false)
      }
    }

    const fetchAllActiveMaritalStatus = async () => {
      try {
        const response = await getAllActiveMaritalStatus("Active")

        if (response.data?.success) {
          setMaritalStatusList(response.data?.marital_statuses)
        }
      } catch (error) {
        console.log(error)
      } finally {
        setLoadingMaritalStatusList(false)
      }
    }

    // เปลี่ยนมาใช้ useAppSelector
    // const fetchAllActiveCompany = async () => {
    //   try {
    //     const response = await getAllActiveCompany(true)

    //     if (response.data?.success) {
    //       setCompanyList(response?.data?.companies)
    //     }
    //   } catch (error) {
    //     console.log(error)
    //     navigate("/servererror", { replace: true })
    //   } finally {
    //     setLoadingCompanyList(false)
    //   }
    // }

    const fetchAllActiveIncentiveGroup = async () => {
      try {
        const response = await getAllActiveIncentiveGroup("Active")

        if (response.data?.success) {
          setIncentiveGroupList(response?.data?.incentiveGroups)
        }
      } catch (error) {
        console.log(error)
        navigate("/servererror", { replace: true })
      } finally {
        setLoadingIncentiveGroupList(false)
      }
    }

    const fetchAllActivePayGrade = async () => {
      try {
        const response = await getAllActivePayGrade("Active")

        if (response.data?.success) {
          setPayGradeList(response?.data?.payGrades)
        }
      } catch (error) {
        console.log(error)
        navigate("/servererror", { replace: true })
      } finally {
        setLoadingPayGradeList(false)
      }
    }

    const fetchAllActiveWorkSchedule = async () => {
      try {
        const response = await getAllActiveWorkSchedule("Active")

        if (response.data?.success) {
          setWorkScheduleList(response?.data?.workSchedules)
        }
      } catch (error) {
        console.log(error)
        navigate("/servererror", { replace: true })
      } finally {
        setLoadingWorkScheduleList(false)
      }
    }

    const fetchAllActiveHolidaySchedule = async () => {
      try {
        const response = await getAllActiveHolidaySchedule("Active")

        if (response.data?.success) {
          setHolidayScheduleList(response?.data?.holidaySchedules)
        }
      } catch (error) {
        console.log(error)
        navigate("/servererror", { replace: true })
      } finally {
        setLoadingHolidayScheduleList(false)
      }
    }

    const fetchAllActiveWorkGroup = async () => {
      try {
        const response = await getAllActiveWorkGroup("Active")

        if (response.data?.success) {
          setWorkGroupList(response?.data?.workGroups)
        }
      } catch (error) {
        console.log(error)
        navigate("/servererror", { replace: true })
      } finally {
        setLoadingWorkGroupList(false)
      }
    }

    const fetchAllActiveBank = async () => {
      try {
        const response = await getAllActiveBank("Active")

        if (response.data?.success) {
          setBankList(response?.data?.banks)
        }
      } catch (error) {
        console.log(error)
        navigate("/servererror", { replace: true })
      } finally {
        setLoadingBankList(false)
      }
    }

    const fetchAllActivePayGroup = async () => {
      try {
        const response = await getAllActivePayGroup("Active")

        if (response.data?.success) {
          setPayGroupList(response?.data?.payGroups)
        }
      } catch (error) {
        console.log(error)
        navigate("/servererror", { replace: true })
      } finally {
        setLoadingPayGroupList(false)
      }
    }
    // เปลี่ยนมาใช้ useAppSelector
    // const fetchActivePrefix = async () => {
    //   try {
    //     const response = await getAllActivePrefix("Active")

    //     if (response.data?.success) {
    //       setPrefixList(response.data?.prefix)
    //     }
    //   } catch (error) {
    //     console.log(error)
    //   }
    // }
    // const fetchSites = async () => {
    //   try {
    //     const response = await getAllSites()

    //     if (response.data?.success) {
    //       const sitesData = response?.data?.sites
    //       const dataSort = sitesData.sort((a: Site, b: Site) =>
    //         a.site_id.localeCompare(b.site_id)
    //       )
    //       setSiteData(dataSort.filter((site: Site) => site.is_active === true))
    //     }
    //   } catch (error) {
    //     navigate("/servererror", { replace: true })
    //   }
    // }

    if (open) {
      fetchAllActiveCountry()
      fetchAllActiveReligion()
      fetchAllActiveMaritalStatus()
      // fetchAllActiveCompany() //เปลี่ยนมาใช้ useAppSelector
      fetchAllActiveIncentiveGroup()
      fetchAllActivePayGrade()
      fetchAllActiveWorkSchedule()
      fetchAllActiveHolidaySchedule()
      fetchAllActiveWorkGroup()
      fetchAllActiveBank()
      fetchAllActivePayGroup()
      // fetchActivePrefix() //เปลี่ยนมาใช้ useAppSelector
      // fetchSites() //เปลี่ยนมาใช้ useAppSelector
    }
  }, [navigate, open])

  // NOTE: isNumeric — ซ้ำกับ admin/PersonalInfo.tsx, users/PersonalInfo.tsx ควรย้ายไปรวมใน utils/validate.ts
  const isNumeric = (value: string): boolean => {
    return /^-?\d+$/.test(value)
  }

  // NOTE: calculateAge — ซ้ำกับ admin/PersonalInfo.tsx, users/PersonalInfo.tsx ควรย้ายไปรวมใน utils/index.ts
  const calculateAge = async (dateOfBirth: Date) => {
    const birth = new Date(dateOfBirth)
    const now = new Date()
    now.setHours(0, 0, 0, 0)

    let age = now.getFullYear() - birth.getFullYear()
    const monthDiff = now.getMonth() - birth.getMonth()
    const dateDiff = now.getDate() - birth.getDate()

    // If the current date hasn't occurred yet this year, subtract 1 from the age.
    if (monthDiff < 0 || (monthDiff === 0 && dateDiff < 0)) {
      age--
    }

    if (isNaN(age)) {
      return "-"
    }
    if (age && age < 18) {
      setAgeStatus(true)
      setTextValidate("text_error_age_application")
    } else {
      setAgeStatus(false)
    }
  }
  const validateThaiCitizenID = async (id: string) => {
    // Remove any non-digit characters from the ID
    id = id.replace(/\D/g, "")

    // Check if the ID has the correct length (13 digits)
    if (id.length !== 13) {
      return false
    }

    // Convert the ID to an array of digits
    const digits = id.split("").map(Number)

    // Calculate the checksum
    let sum = 0
    for (let i = 0; i < 12; i++) {
      sum += digits[i] * (13 - i)
    }

    // Check if the last digit matches the checksum
    const checksum = (11 - (sum % 11)) % 10

    return digits[12] === checksum
  }

  const checkIDCard = async (id: string) => {
    const validateStatus = await validateThaiCitizenID(id)
    if (validateStatus && isNumeric(id)) {
      checkMemberIdCard(id)
      setIdCardNumber(id)
      setStatusValidate(false)
    } else {
      setStatusValidate(true)
      setTextValidate("text_error_validate_idCard")
      // Swal.fire({
      //   icon: "error",
      //   text: `${t("text_error_validate_idCard")}`,
      // })
    }
  }
  const checkMemberIdCard = async (idCard: string) => {
    try {
      const response = await checkUsername(idCard)
      if (response.data?.success) {
        setStatusValidate(false)
        setDupUserId("text_err_id_mrmber_old_2")
        // Swal.fire({
        //   icon: "warning",
        //   text: `${idCard} ${t("text_err_id_mrmber_old")}`,
        //   allowOutsideClick: false,
        //   allowEscapeKey: false,
        // }).then((result) => {
        //   if (result.isConfirmed) {
        //     sessionStorage.setItem("nextStep", "appform")
        //     window.location.assign(`/login/${idCard}`)
        //   }
        // })
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    setValue("site", selectedSite, { shouldValidate: true })
    // setSelectedSiteOption(
    //   siteData
    //     .filter((item) => item.site_id === selectedSite)
    //     .map((site1) => ({
    //       site_id: site1.site_id,
    //       site_name: site1.site_name,
    //     }))[0]
    // )
  }, [selectedSite, siteData])
  useEffect(() => {
    setValue("company", selectedCompany, { shouldValidate: true })
  }, [selectedCompany])
  useEffect(() => {
    setValue("workSchedule", selectedWorkSchedule, { shouldValidate: true })
  }, [selectedWorkSchedule])
  useEffect(() => {
    setValue("holiday_schedule", selectedHolidaySchedule, {
      shouldValidate: true,
    })
  }, [selectedHolidaySchedule])
  useEffect(() => {
    setValue("payGroup", selectedPayGroup, { shouldValidate: true })
  }, [selectedPayGroup])
  // NOTE: blockInvalidChar — ซ้ำกับ admin/PersonalInfo.tsx, users/PersonalInfo.tsx ควรย้ายไปรวมใน utils/index.ts
  const blockInvalidChar = (e: any) =>
    ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()

  useEffect(() => {
    if (personalInfo && personalInfo?.id_card_number?.length === 13 && open) {
      checkIDCard(personalInfo.id_card_number)
    }
    if (personalInfo && personalInfo?.date_of_birth) {
      calculateAge(personalInfo.date_of_birth)
    }
  }, [personalInfo, open])

  const onSubmitted = async () => {
    try {
      setIsLoading(true)
      const data = {
        user_id: edit_id,
        app_form_status_id: edit_id,
        modified_by: parsedToken.Username,
        personalInfo,
        contactInfo,
        educationInfo,
        legalAddressInfo,
        mailingAddressInfo,
        jobInfo,
      }

      const response = await editAppFormById(data)
      if (response.data?.success) {
        setIsLoading(false)
        onClose()

        Swal.fire({
          icon: "success",
          title: `${t("Success")}`,
          text: `${t("Editsuccess")}`,
          confirmButtonText: `${t("ok")}`,
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.reload()
          }
        })
      } else {
        setIsLoading(false)
        onClose()
        Swal.fire({
          icon: "error",
          title: `${t("Error")}`,
          text: `${t("ECfailed")}  ${t(dupUserId)}`,
          confirmButtonText: `${t("ok")}`,
        })
      }
    } catch (error) {
      navigate("/servererror", { replace: true })
    }
  }
  return (
    <ThemeProvider theme={theme}>
      <Dialog
        sx={{ "& .MuiDialog-paper": { width: "100%", position: "relative" } }}
        maxWidth="lg"
        open={open}
        {...other}
      >
        <DialogTitle
          id="scroll-dialog-title"
          sx={{ fontWeight: "bold", fontSize: { xs: 16, sm: 18 } }}
        >
          {t("Edit Job Informations")}
        </DialogTitle>
        {(statusValidate || ageStatus) && (
          <Alert severity="error">
            <AlertTitle>Error</AlertTitle>
            {t(textValidate)}
          </Alert>
        )}
        {isLoading && (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(255, 255, 255, 0.7)",
              zIndex: 9999,
              borderRadius: "inherit",
            }}
          >
            <CircularProgress color="primary" />
          </Box>
        )}
        <DialogContent
          dividers
          sx={{ display: "flex", flexDirection: "column" }}
        >
          {appFormData?.AppFormData && (
            <div>
              <PersonalInfo
                data={appFormData?.AppFormData}
                errors={personalInfoErrors}
              />
              <ContactInfo
                data={appFormData?.AppFormData}
                errors={contactInfoErrors}
              />
              <EducationInfo
                data={appFormData?.AppFormData}
                errors={educationInfoErrors}
              />
              <MilitaryInfo
                data={appFormData?.AppFormData}
                errors={militaryInfoErrors}
              />
              <AddressInfo
                data={appFormData?.AppFormData}
                same_address={appFormData?.AppFormData?.same_address}
                legalErrors={legalAddressInfoErrors}
                mailingErros={mailingAddressInfoErrors}
              />
            </div>
          )}
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            px: 3,
            py: 2,
          }}
        >
          <Box sx={{ display: "flex", gap: 1 }}>
            <Button
              color="error"
              variant="contained"
              onClick={() => {
                onClose()
                setLoadingECData(true)
              }}
              sx={{ px: 3 }}
            >
              {t("Cancel")}
            </Button>
          </Box>

          <Button
            variant="contained"
            color="primary"
            // onClick={handleClick}
            onClick={handleSubmit(onSubmitted)}
            sx={{ px: 3 }}
            disabled={statusValidate || ageStatus}
          >
            {t("Confirm")}
            {submittedLoading && (
              <CircularProgress
                size={24}
                sx={{
                  color: green[500],
                  position: "absolute",
                  zIndex: 999,
                }}
              />
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  )
}
